import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

interface TabItem {
    value: string;
    label: string;
}

interface TabProp {
    setTabValue: (value: any) => void;
    tabs: TabItem[];
    tabValue: string;
}
const TAB_FONT_COLOR = '#202A44';
export default function ColorTabs({ tabValue, setTabValue, tabs, ...props }: TabProp) {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }} {...props}>
            <Tabs
                value={tabValue}
                onChange={handleChange}
                sx={{
                    '& .MuiTabs-indicator': {
                        backgroundColor: TAB_FONT_COLOR,
                    },
                    '& .MuiTab-textColorPrimary': {
                        color: TAB_FONT_COLOR, // selected tabs
                    },
                    '& .MuiTab-root.MuiTab-textColorPrimary:not(.Mui-selected)': {
                        color: '#9CA3AF', // Change this to the color you want for non-selected tabs
                    },
                }}
                TabIndicatorProps={{ color: 'red' }}
                aria-label="secondary tabs example"
                variant="scrollable"
                scrollButtons={false}
            >
                {tabs.map((tab) => (
                    <Tab
                        key={tab.value}
                        value={tab.value}
                        label={tab.label}
                        style={{ color: tab.value === tabValue ? TAB_FONT_COLOR : 'gray' }}
                    />
                ))}
            </Tabs>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}></div>
        </Box>
    );
}
